import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useCreditInfo } from 'hook/data/creditInfo.hook';
import { useEventHandler, useScoreChangeHandler } from 'hook/event.hook';
import { loadCreditRepairExpertSim } from 'actions/actions.actions';
import { CLICK_APPLY, CLICK } from 'externals/_tracking/types/eventTypes.constants.js';
import { CREDIT_REPAIR_VERTICAL } from 'types/mrph.vertical.constants';

const useCreditRepairExpertHook = props => {
  const dispatch = useDispatch();
  const creditInfo = useCreditInfo();
  const history = useHistory();
  const eventHandler = useEventHandler();

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const {
    creditRepairExpertSim,
    creditRepairExpertSimLoading,
    creditRepairExpertSimError,
  } = useSelector(state => {
    return {
      creditRepairExpertSim: state.actions.creditRepairExpertSim,
      creditRepairExpertSimLoading: state.actions.creditRepairExpertSimLoading,
      creditRepairExpertSimError: state.actions.creditRepairExpertSimError,
    };
  });

  useEffect(() => {
    const requestSimulation =
      !creditRepairExpertSim &&
      !creditRepairExpertSimLoading &&
      creditRepairExpertSimError === null;

    if (requestSimulation) {
      dispatch(loadCreditRepairExpertSim(creditInfo))
        .catch(error => {
          setError(error);
        })
        .finally(_ => setLoading(false));
    }

    if (creditRepairExpertSim || creditRepairExpertSimError) {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    creditRepairExpertSim,
    creditRepairExpertSimLoading,
    creditRepairExpertSimError,
    creditInfo,
  ]);

  const tabClickEventCallback = useScoreChangeHandler(eventHandler);
  const tabClickEventHandler = (key, e) => {
    tabClickEventCallback({
      tab: key,
      "Page Position": 'Credit Repair Expert',
      "Module Name": 'Simulation',
      Vertical: CREDIT_REPAIR_VERTICAL,
    });
  };

  const onClickApply = () => {
    eventHandler(CLICK_APPLY, {
      'Click Type': 'Apply',
      Vertical: CREDIT_REPAIR_VERTICAL,
    });
  };

  const onClickCollapse = () => {
    eventHandler(CLICK, {
      'Click Type': 'See negative marks',
      Vertical: CREDIT_REPAIR_VERTICAL,
    });
  }

  function homePageHandler() {
    history.goBack();
  }

  function getScoreSimulationForMonth(sixthMonth = false) {
    if (creditRepairExpertSim) {
      const creditScore = creditInfo ? creditInfo.creditInfo.creditScore : null;
      return sixthMonth
        ? creditRepairExpertSim.scoreOverTimeData[6][0].score - creditScore
        : creditRepairExpertSim.scoreOverTimeData[1][0].score - creditScore;
    }
    return null;
  }

  return {
    error,
    loading,
    creditRepairExpertSim,
    firstMonthScoreChange: getScoreSimulationForMonth(),
    sixthMonthScoreChange: getScoreSimulationForMonth(true),
    tabClickEventHandler,
    onClickApply,
    homePageHandler,
    onClickCollapse,
  };
};

export default useCreditRepairExpertHook;
